// 作成済書類 外注発注書一覧画面
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Radio,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  Grid
} from '@material-ui/core';
import { DialogProps } from '@material-ui/core/Dialog';
import RadioGroup from '@material-ui/core/RadioGroup';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import CreateIcon from '@material-ui/icons/Create';
import DeleteIcon from '@material-ui/icons/Delete';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import GetAppIcon from '@material-ui/icons/GetApp';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import 'date-fns';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { Redirect, useHistory } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { useRecoilState } from 'recoil';
import { getAllConstructionList } from '../apicalls/construction';
import { getEmployeeMasterList } from '../apicalls/employeeMaster';
import {
  copyOutSources,
  deleteOutsourceList,
  deleteSingleOutsource,
  getExportOutsourcesItems,
  getOutSourceDetails,
  getOutSourceList,
  updateOutSourceInvoiceBillingTotal,
  updateOutsourcePurchaseMemo,
  partialUpdateOutsourceStatus
} from '../apicalls/outsource';
import { savePdf } from '../apicalls/savePdf';
import '../App.css';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import LoadingComponent from '../components/LoadingComponent';
import { MemoDialog } from '../components/MemoDialog';
import NumberInputProductPurchaseOrders from '../components/NumberInputProductPurchaseOrders';
import PaginationComponent from '../components/PaginationComponent';
import SortButton from '../components/SortButton';
import { outsourcePdf } from '../generatePdf/outsourcePdf';
import {
  btnColor,
  employeeMasterData,
  isLoggedIn,
  mainBlueColor,
  outsourceData,
  userRole
} from '../GlobalState';
import { parsePrice } from '../utils';
import './List.css';
import { DOCUMENT_TYPE, EMPLOYEE_TYPE } from '../const/Const';
import { DatePickerInput } from '../components/atoms';
import { formatDatetime } from '../utils/common';
import { AlertModal } from '../components/parts/cloudStorage/AlertModal';
import {
  getCustomerDetails,
  getPartnerDetails
} from '../apicalls/createCustomer';
import { BasicSelect } from '../components/parts/input/BasicSelect';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { TParams } from '../types/OutSourcedPurchaseOrder';
import { getUserSelectOptions } from '../utils/processAndTaskFormUtils';
import { SearchConstruction } from './SearchConstruction';
import { useSnackbar } from 'notistack';
import { checkResData } from '../utils/common';

const StyledTableCellSite = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  },
  root: {
    borderBottom: 'none',
    padding: 0
  }
}))(TableCell);

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

interface State {
  arr: any;
}

interface CheckedState {
  check: any;
}

export const OutsourcedPurchaseOrder: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [userPermission] = useRecoilState(userRole);

  const [selectedConstructId, setSelectedConstructId] = useState(0);
  const [originalConstructId, setOriginalConstructId] = useState(0);
  const [selectedOutsourceId, setSelectedOutsourceId] = useState(0);
  const [openCopyDialog, setOpenCopyDialog] = useState(false);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      formControl1: {
        minWidth: 120,
        height: 30,
        borderRadius: 5,
        borderWidth: 1,
        paddingLeft: 5
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      },
      main: {
        minWidth: 700
      },
      table: {
        padding: 8,
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: 16
      },
      input: {
        borderColor: '#CCCCCC',
        // padding: 5,
        margin: 10
      },
      table1: {
        // padding: 8,
      },
      subTable1: {
        // padding: 8,
        borderBottom: 'none'
      },
      topBoxText: {
        fontSize: 14,
        color: '#000000'
      },
      topContainer: {
        display: 'flex',
        paddingBottom: 15,
        justifyContent: 'space-between'
      },
      btnContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      },
      inputBottom: {
        height: 30,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      tooltip_old: {
        maxWidth: 300
      },
      searchField: {
        overflow: 'hidden',
        width: window.innerWidth,
        display: 'flex',
        flexWrap: 'wrap'
      },
      subCell: {
        padding: 8,
        borderRight: '1px #CCCCCC solid',
        borderLeft: '1px #CCCCCC solid',
        borderBottom: `1px ${mainColor} solid`
      },
      multiLinesTable: {
        padding: 0,
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontWeight: 'bold'
      },
      topList: {
        display: 'flex',
        marginTop: 25,
        marginBottom: 25,
        width: '100%',
        justifyContent: 'flex-start'
      },
      submitButton: {
        backgroundColor: '#007dff',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#2691ff',
          boxShadow: 3
        }
      },
      cancelButton: {
        backgroundColor: '#bdbdbd',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#cccccc',
          boxShadow: 3
        }
      },
      copyStateMessage: {
        // リンクURLコピーの成否メッセージ
        position: 'fixed',
        left: 60,
        bottom: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: 300,
        padding: '12px 24px',
        borderRadius: 8,
        color: 'white',
        backgroundColor: 'black',
        fontSize: 14,
        opacity: 0.8
      }
    })
  );

  const matches2 = useMediaQuery('(min-width:960px)');
  const classes = useStyles();
  const history: any = useHistory();

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [outsourceApiData, setOutsourceApiData] = useRecoilState(outsourceData);
  const changeOutsourceApiData = useCallback(
    (newData: any) => setOutsourceApiData(newData),
    [setOutsourceApiData]
  );
  const [employeeMasterApiData, setEmployeeMasterApiData] =
    useRecoilState(employeeMasterData);
  const changeEmployeeMasterApiData = useCallback(
    (newData: any) => setEmployeeMasterApiData(newData),
    [setEmployeeMasterApiData]
  );
  const [apiData, setApiData] = useState<any>(
    outsourceApiData !== null ? outsourceApiData : []
  );
  const [loading, setLoading] = useState(
    outsourceApiData !== null ? false : true
  );
  const [userData, setUserData] = useState<any>(
    employeeMasterApiData !== null ? employeeMasterApiData : []
  );

  const [clickedDocumentId, setClickedDocumentId] = useState<any>([]);

  const [checkBoxSelected, setCheckBoxSelected] = useState(false);

  const [status, setStatus] = useState<number>(0);
  const [constructSub, setConstructSub] = useState('');
  const [constructCode, setConstructCode] = useState('');
  const [userId, setUserId] = useState<number>(0);
  const [supplierName, setSupplierName] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [constructEndDate, setConstructEndDate] = useState('');
  const [constructFromDate, setConstructFromDate] = useState('');
  const [jobEndDate, setJobEndDate] = useState('');
  const [jobFromDate, setJobFromDate] = useState('');
  const [orderFromDate, setOrderFromDate] = useState('');
  const [orderDate, setOrderDate] = useState('');
  const [prefecture, setPrefecture] = useState('');
  const [address, setAddress] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(
    history.location.state?.currentPage || 1
  );

  const savedDisplayLimit = localStorage.getItem('displayLimit');
  const [displayLimit, setDisplayLimit] = useState<number>(
    savedDisplayLimit ? parseInt(savedDisplayLimit, 10) : 10
  );

  const handleDisplayLimitChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const value = parseInt(e.target.value, 10); // 10進数基数を指定
    setDisplayLimit(value);
    localStorage.setItem('displayLimit', value.toString());
    setCurrentPage(1);
  };

  const [openModal, setOpenModal] = useState(false);

  const [selectedIds, setSelectedIds] = useState<State>({ arr: [] });
  const [checked, setChecked] = useState<CheckedState>({ check: [] });
  const [pressed, setPressed] = useState([]);
  const [isSelected, setSelection] = useState(false);

  const [openAlert, setOpenAlert] = useState(false);
  const [openAlertSingle, setOpenAlertSingle] = useState(false);
  const [count, setCount] = useState<number>(0);
  const [idToDelete, setIdToDelete] = useState<number>(0);

  const [myCheckExport, setMyCheckExport] = useState<any>([]);
  const [transactionData, setTransactionData] = useState<any>([]);
  const [consrtuctionData, setConstructionData] = useState<any>([]);
  const [openSelectModal, setopenSelectModal] = useState(false);
  const [constructId, setConstructId] = useState('');

  const [openMemoDialog, setOpenMemoDialog] = useState(false);
  const [memoDialog, setMemoDialog] = useState('');
  const [memoId, setMemoId] = useState<number>(0);
  const [billingTotalStart, setBillingTotalStart] = useState<any>(null);
  const [billingTotalEnd, setBillingTotalEnd] = useState<any>(null);
  const [copyStart, setCopyStart] = useState<boolean>(false);

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  // モーダル内工事検索
  const [constructSubForCreate, setConstructSubForCreate] = useState('');
  const [constructSubForCopy, setConstructSubForCopy] = useState('');
  const [filteredConstructionData, setFilteredConstructionData] = useState<any>(
    []
  );

  // リンクURLコピーの成否メッセージ
  const [copyStateMessage, setCopyStateMessage] = useState<string>();
  // コピーの成否メッセージの表示フラグ
  const [openCopyStateMessage, setOpenCopyStateMessage] =
    useState<boolean>(false);

  const [clientName, setClientName] = useState('');
  const [clientEmail, setClientEmail] = useState('');
  const [clientCompanyName, setClientCompanyName] = useState('');
  const [documentId, setDocumentId] = useState(null);
  const [documentName, setDocumentName] = useState('');
  const [params, setParams] = useState<TParams>();
  const csvLink: any = useRef();
  const [transitionFlg, setTransitionFlg] = useState(
    history.location.state ? true : false
  );
  const checkListOptions = [
    { code: '外注発注書番号' },
    { user_id: '作成者' },
    { supervisor_id: '担当者氏名' },
    { order_date: '発注日' },
    { status: 'ステータス' },
    { construct_sub: '工事件名' },
    { billing_note: '発注注意事項' },
    { partner_id: '発注先業者名' },
    { vendor_representative: '発注先代表者' },
    { vendor_supervisor: '発注先担当者' },
    { total_amount: '予定原価合計(税抜)' },
    { total_price: '予定原価合計(税込)' },
    { invoice_billing_total: '請求金額(税込)' },
    { memo: 'メモ' },
    { closing_date: '締日' },
    { payment_site_month: '支払月' },
    { payment_site_date: '支払日' },
    { job_start_date: '開始日' },
    { job_end_date: '終了日' }
  ];
  //{"user_id":"作成者"},{"job_start_date":"開始日"},{"job_end_date":"終了日"},{"supervisor_id":"担当者氏名"},{"billing_note":"発注注意事項"},{"partner_id":"発注先業者名"},{"vendor_representative":"発注先代表者"},{"vendor_supervisor":"発注先担当者"},{"billing_total":"合計金額"},{"construction_name":"工事内容"},{"quantity":"数量"},{"unit":"単位"},{"unit_price":"単価"},{"amount":"合計金額"}  ,{"construction_name":"工事内容"},{"quantity":"数量"},{"unit":"単位"},{"unit_price":"単価"},{"amount":"合計金額"}   {"construct_sub":"工事件名"},{"site_user_name":"営業担当"},{"construct_type":"工事種別"},{"partner":"発注先"},{"total_amount":"予定原価合計"},
  // 日付ソート用
  const [sortParams, setSortParams] = useState<any>({
    sort_field: null,
    sort_direction: null
  });
  const [sortButtonName, setSortButtonName] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const changeSortParams = (params: any) => {
    setSortParams(params);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleClickOpenAlert = () => {
    if (userPermission !== 1) {
      setErrorMessage('削除の権限がありません。');
      setOpen(true);
    } else {
      setOpenAlert(true);
    }
  };

  const handleCloseAlertSingle = () => {
    setOpenAlertSingle(false);
  };

  const handleClickOpenAlertSingle = () => {
    if (userPermission !== 1) {
      setErrorMessage('削除の権限がありません。');
      setOpen(true);
    } else {
      setOpenAlertSingle(true);
    }
  };

  const handleCloseCopyDialog = () => {
    setOpenCopyDialog(false);
  };

  const handleCloseMemoDialog = () => {
    setOpenMemoDialog(false);
  };

  const handleToggleSetConstruct = () => {
    if (selectedConstructId === originalConstructId) {
      setSelectedConstructId(0);
    } else {
      setSelectedConstructId(originalConstructId);
    }
  };

  function handleChange(index: number) {
    for (let i = 0; i < count; i++) {
      if (checked.check[i] === false) {
        setSelection(false);
      }
    }

    let checkedBox: any = [...checked.check];
    checkedBox[index] = !checked.check[index];
    setChecked({ check: checkedBox });
  }

  const selectAllCheckBoxPressed = () => {
    let a = [];
    if (isSelected === false) {
      let subjectArray: any = [];
      setSelectedIds({ arr: [] });

      setChecked({ check: [] });
      setPressed([]);
      for (let i = 1; i <= count; i++) {
        a.push(true);
        setChecked({ check: a });
      }

      apiData.map((item: any, k: number) => subjectArray.push(item.id));
      setSelectedIds({ arr: subjectArray });
    } else {
      setSelectedIds({ arr: [] });
      for (let i = 1; i <= count; i++) {
        a.push(false);
        setChecked({ check: a });
      }
    }
  };

  const [selectedConstructEndDate, setSelectedConstructEndDate] =
    useState<Date | null>(null);
  const [selectedConstructFromDate, setSelectedConstructFromDate] =
    useState<Date | null>(null);
  const [selectedJobEndDate, setSelectedJobEndDate] =
    useState<Date | null>(null);
  const [selectedJobFromDate, setSelectedJobFromDate] =
    useState<Date | null>(null);
  const [selectedOrderFromDate, setSelectedOrderFromDate] =
    useState<Date | null>(null);
  const [selectedOrderDate, setSelectedOrderDate] = useState<Date | null>(null);

  /**
   * 工事の竣工日:開始
   */
  const handleConstructFromDateChange = (date: Date | null) => {
    setSelectedConstructFromDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setConstructFromDate(finaldate);
    setParams(prevParams => ({
      ...prevParams,
      selectedConstructFromDate: date
    }));
    setParams(prevParams => ({ ...prevParams, constructFromDate: finaldate }));
  };

  /**
   * 工事の竣工日:終了
   */
  const handleConstructEndDateChange = (date: Date | null) => {
    setSelectedConstructEndDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setConstructEndDate(finaldate);
    setParams(prevParams => ({
      ...prevParams,
      selectedConstructEndDate: date
    }));
    setParams(prevParams => ({ ...prevParams, constructEndDate: finaldate }));
  };

  /**
   * 支払予定日:開始
   */
  const handleJobFromDateChange = (date: Date | null) => {
    setSelectedJobFromDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setJobFromDate(finaldate);
    setParams(prevParams => ({ ...prevParams, selectedJobFromDate: date }));
    setParams(prevParams => ({ ...prevParams, jobFromDate: finaldate }));
  };

  /**
   * 支払予定日:終了
   */
  const handleJobEndDateChange = (date: Date | null) => {
    setSelectedJobEndDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setJobEndDate(finaldate);
    setParams(prevParams => ({ ...prevParams, selectedJobEndDate: date }));
    setParams(prevParams => ({ ...prevParams, jobEndDate: finaldate }));
  };

  /**
   * 発注日:開始
   */
  const handleOrderFromDateChange = (date: Date | null) => {
    setSelectedOrderFromDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setOrderFromDate(finaldate);
    setParams(prevParams => ({ ...prevParams, selectedOrderFromDate: date }));
    setParams(prevParams => ({ ...prevParams, orderFromDate: finaldate }));
  };

  /**
   * 発注日:終了
   */
  const handleOrderDateChange = (date: Date | null) => {
    setSelectedOrderDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setOrderDate(finaldate);
    setParams(prevParams => ({ ...prevParams, selectedOrderDate: date }));
    setParams(prevParams => ({ ...prevParams, orderDate: finaldate }));
  };

  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const getListOfUsers = useCallback(() => {
    getEmployeeMasterList('', 1, 0, EMPLOYEE_TYPE['INSIDE_EMPLOYEE']).then(
      data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              changeEmployeeMasterApiData(data.data);
              setUserData(data.data);
            }
          }
        }
      }
    );
  }, [changeLoggedInData, changeEmployeeMasterApiData]);

  const getAllListConstruction = useCallback(() => {
    getAllConstructionList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setConstructionData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfOutSource = useCallback(() => {
    let paramDatas = {
      status: status,
      constructSub: constructSub.trim(),
      constructCode: constructCode.trim(),
      userId: userId,
      supplierName: supplierName.trim(),
      customerName: customerName.trim(),
      constructFromDate:
        selectedConstructFromDate !== null ? constructFromDate : '',
      constructEndDate:
        selectedConstructEndDate !== null ? constructEndDate : '',
      jobFromDate: selectedJobFromDate !== null ? jobFromDate : '',
      jobEndDate: selectedJobEndDate !== null ? jobEndDate : '',
      orderFromDate: selectedOrderFromDate !== null ? orderFromDate : '',
      orderDate: selectedOrderDate !== null ? orderDate : '',
      prefecture: prefecture.trim(),
      address: address,
      currentPage: currentPage,
      displayLimit: displayLimit,
      billingTotalStart: billingTotalStart,
      billingTotalEnd: billingTotalEnd,
      sortParams: {
        sort_direction: sortParams.sort_direction,
        sort_field: sortParams.sort_field
      }
    };

    if (transitionFlg) {
      const params: TParams | undefined = history.location.state.params;
      if (params) {
        paramDatas = {
          status: params.status ? params.status : 0,
          constructSub: params.constructSub ? params.constructSub.trim() : '',
          constructCode: params.constructCode
            ? params.constructCode.trim()
            : '',
          userId: params.userId ? params.userId : 0,
          supplierName: params.supplierName ? params.supplierName.trim() : '',
          customerName: params.customerName ? params.customerName.trim() : '',
          constructFromDate: params.constructFromDate
            ? params.constructFromDate
            : '',
          constructEndDate: params.constructEndDate
            ? params.constructEndDate
            : '',
          jobFromDate: params.jobFromDate ? params.jobFromDate : '',
          jobEndDate: params.jobEndDate ? params.jobEndDate : '',
          orderFromDate: params.orderFromDate ? params.orderFromDate : '',
          orderDate: params.orderDate ? params.orderDate : '',
          prefecture: params.prefecture ? params.prefecture.trim() : '',
          address: params.address ? params.address : '',
          currentPage: 1,
          displayLimit: 10,
          billingTotalStart: params.billingTotalStart
            ? params.billingTotalStart
            : null,
          billingTotalEnd: params.billingTotalEnd
            ? params.billingTotalEnd
            : null,
          sortParams: params.sortParams
            ? {
                sort_direction: params.sortParams.sort_direction
                  ? params.sortParams.sort_direction
                  : null,
                sort_field: params.sortParams.sort_field
                  ? params.sortParams.sort_field
                  : null
              }
            : {
                sort_direction: null,
                sort_field: null
              }
        };
      }
    }

    getOutSourceList(
      paramDatas.status,
      paramDatas.constructSub,
      paramDatas.constructCode,
      paramDatas.userId,
      paramDatas.supplierName,
      paramDatas.customerName,
      paramDatas.constructFromDate,
      paramDatas.constructEndDate,
      paramDatas.jobFromDate,
      paramDatas.jobEndDate,
      paramDatas.orderFromDate,
      paramDatas.orderDate,
      paramDatas.prefecture,
      paramDatas.address,
      paramDatas.currentPage,
      paramDatas.displayLimit,
      paramDatas.billingTotalStart,
      paramDatas.billingTotalEnd,
      paramDatas.sortParams.sort_direction,
      paramDatas.sortParams.sort_field
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setClickedDocumentId([]);
            changeOutsourceApiData(data.data);
            setApiData(data.data);
            setLoading(false);
            setCount(data.data.length);
            setSelectedIds({ arr: [] });
            setChecked({ check: [] });
            setSelection(false);
            setPageCount(data.page_count);
            setMyCheckExport(data.selected_columns);
          }
        }
      }
    });
  }, [
    changeLoggedInData,
    changeOutsourceApiData,
    constructEndDate,
    constructSub,
    constructCode,
    currentPage,
    customerName,
    displayLimit,
    jobEndDate,
    orderDate,
    selectedConstructEndDate,
    selectedConstructFromDate,
    selectedJobFromDate,
    selectedOrderFromDate,
    selectedJobEndDate,
    selectedOrderDate,
    status,
    supplierName,
    userId,
    prefecture,
    address,
    billingTotalStart,
    billingTotalEnd,
    constructFromDate,
    jobFromDate,
    orderFromDate,
    sortParams
  ]);

  useEffect(() => {
    // 画面遷移の際のステートがなければ処理しない
    if (!history.location.state) return;

    // パラメーター取得
    const params: TParams | undefined = history.location.state.params;
    setParams(params);

    if (params) {
      setStatus(params.status ? params.status : 0); // ステータス設定
      setConstructSub(params.constructSub ? params.constructSub : ''); // 工事件名設定
      setConstructCode(params.constructCode ? params.constructCode : ''); // 工事番号設定
      setUserId(params.userId ? params.userId : 0); // 営業担当設定
      setSupplierName(params.supplierName ? params.supplierName : ''); // 発注先設定
      setCustomerName(params.customerName ? params.customerName : ''); // 顧客名設定
      setSelectedConstructFromDate(
        params.selectedConstructFromDate
          ? params.selectedConstructFromDate
          : null
      ); // 竣工開始日(検索窓への入力)設定
      setConstructFromDate(
        params.constructFromDate ? params.constructFromDate : ''
      ); // 竣工開始日設定
      setSelectedConstructEndDate(
        params.selectedConstructEndDate ? params.selectedConstructEndDate : null
      ); // 竣工終了日(検索窓への入力)設定
      setConstructEndDate(
        params.constructEndDate ? params.constructEndDate : ''
      ); // 竣工終了日設定
      setSelectedJobFromDate(
        params.selectedJobFromDate ? params.selectedJobFromDate : null
      ); // 支払予定開始日(検索窓への入力)設定
      setJobFromDate(params.jobFromDate ? params.jobFromDate : ''); // 支払予定開始日設定
      setSelectedJobEndDate(
        params.selectedJobEndDate ? params.selectedJobEndDate : null
      ); // 支払予定終了日(検索窓への入力)設定
      setJobEndDate(params.jobEndDate ? params.jobEndDate : ''); // 支払予定終了日設定
      setSelectedOrderFromDate(
        params.selectedOrderFromDate ? params.selectedOrderFromDate : null
      ); // 発注開始日(検索窓への入力)設定
      setOrderFromDate(params.orderFromDate ? params.orderFromDate : ''); // 発注開始日設定
      setSelectedOrderDate(
        params.selectedOrderDate ? params.selectedOrderDate : null
      ); // 発注終了日(検索窓への入力)設定
      setOrderDate(params.orderDate ? params.orderDate : ''); // 発注終了日設定
      setBillingTotalStart(
        params.billingTotalStart ? params.billingTotalStart : null
      ); // 原価予定合計開始設定
      setBillingTotalEnd(
        params.billingTotalEnd ? params.billingTotalEnd : null
      ); // 原価予定合計終了設定
      setPrefecture(params.prefecture ? params.prefecture : ''); // 都道府県設定
      setSortParams(
        params.sortParams
          ? {
              sort_direction: params.sortParams.sort_direction,
              sort_field: params.sortParams.sort_field
            }
          : { sort_direction: null, sort_field: null }
      ); // ソート設定
      setTransitionFlg(false); // 画面遷移フラグ
    }
  }, []);

  // input入力検知用
  const [timer, setTimer] = useState<any>(null);

  // 請求金額を記録する用
  const [invoiceBillingTotals, setInvoiceBillingTotals] = useState<
    Array<{ id: number; invoice_billing_total: number }>
  >([]);
  const [calcInvoiceBillingTotals, setCalcInvoiceBillingTotals] =
    useState(false);

  // 外注発注全ての請求金額を変更する用の関数
  const changeInvoiceBillingTotals = useCallback(async () => {
    setCalcInvoiceBillingTotals(true);
    const invoiceBillingTotals: Array<{
      id: number;
      invoice_billing_total: number;
    }> = [];
    await apiData.forEach((item: any) => {
      invoiceBillingTotals.push({
        id: item.id,
        invoice_billing_total: item.invoice_billing_total
          ? item.invoice_billing_total
          : undefined
      });
    });
    setInvoiceBillingTotals(invoiceBillingTotals);
    setCalcInvoiceBillingTotals(false);
  }, [apiData]);

  // 単一外注発注の請求金額を変更する用の関数（請求金額入力欄から外れたときに発火させる）
  const changeInvoiceBillingTotal = useCallback(
    (id: number, input: number) => {
      updateOutSourceInvoiceBillingTotal(id, input).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              getListOfOutSource();
            }
          }
        }
      });
    },
    [changeLoggedInData, getListOfOutSource]
  );

  useEffect(() => {
    getListOfUsers();
    getAllListConstruction();
    changeInvoiceBillingTotals();
  }, [getListOfUsers, getAllListConstruction, changeInvoiceBillingTotals]);

  useEffect(() => {
    setCurrentPage(history.location.state?.currentPage || 1);
  }, [
    status,
    constructSub,
    userId,
    supplierName,
    customerName,
    selectedConstructFromDate,
    selectedConstructEndDate,
    selectedJobFromDate,
    selectedJobEndDate,
    selectedOrderFromDate,
    selectedOrderDate,
    prefecture,
    address,
    billingTotalStart,
    billingTotalEnd
  ]);

  useEffect(() => {
    getListOfOutSource();
  }, [
    status,
    constructSub,
    constructCode,
    userId,
    supplierName,
    customerName,
    selectedConstructFromDate,
    selectedConstructEndDate,
    selectedJobFromDate,
    selectedJobEndDate,
    selectedOrderFromDate,
    selectedOrderDate,
    prefecture,
    address,
    currentPage,
    displayLimit,
    sortParams,
    sortButtonName,
    billingTotalStart,
    billingTotalEnd
  ]);

  // 見積書新規作成 モーダル内工事検索
  useEffect(() => {
    const filteredDataForCreate = SearchConstruction(
      consrtuctionData,
      constructSubForCreate
    );
    setFilteredConstructionData(filteredDataForCreate);
  }, [consrtuctionData, constructSubForCreate]);

  // 見積書コピー モーダル内工事検索
  useEffect(() => {
    const filteredDataForCopy = SearchConstruction(
      consrtuctionData,
      constructSubForCopy
    );
    setFilteredConstructionData(filteredDataForCopy);
  }, [consrtuctionData, constructSubForCopy]);

  const deleteSelectedOutsources = () => {
    deleteOutsourceList(selectedIds.arr).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setOpenAlert(false);
            getListOfOutSource();
          }
        }
      }
    });
  };

  const deleteOutsourceById = () => {
    deleteSingleOutsource(idToDelete).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setOpenAlert(false);
            getListOfOutSource();
          }
        }
      }
    });
  };

  const copySelectedOutSources = (id: number, constructId: number) => {
    if (constructId === 0) {
      setErrorMessage('コピー先の工事を選択してください。');
      setOpen(true);
      return;
    }
    copyOutSources(id, constructId).then(copyRes => {
      // PDF保存
      getOutSourceDetails(copyRes.data).then(data => {
        if (data === 'Not logged in!') {
          setCopyStart(false);
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setCopyStart(false);
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setCopyStart(false);
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              copyPdf(data.data, data.data.id);
            }
          }
        }
      });
    });
  };

  const updateStatus = (id: number, status: number) => {
    partialUpdateOutsourceStatus(id, status).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            checkResData(data, enqueueSnackbar).then(() => {
              getListOfOutSource();
            });
          }
        }
      }
    });
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleExport = () => {
    if (myCheckExport.length === 0) {
      setErrorMessage('エクスポートする項目を選択してください。');
      setOpen(true);
      return;
    }
    getExportOutsourcesItems(
      myCheckExport,
      status,
      constructSub,
      userId,
      supplierName,
      customerName,
      selectedConstructFromDate !== null ? constructFromDate : '',
      selectedConstructEndDate !== null ? constructEndDate : '',
      selectedJobFromDate !== null ? jobFromDate : '',
      selectedJobEndDate !== null ? jobEndDate : '',
      prefecture.trim(),
      address,
      selectedOrderFromDate !== null ? orderFromDate : '',
      selectedOrderDate !== null ? orderDate : ''
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setTransactionData(data.rows_list);
            csvLink.current.link.click();
            handleCloseModal();
          }
        }
      }
    });
  };

  const copyPdf = async (pdfData: any, docId: number) => {
    let blob = await outsourcePdf(pdfData);

    const formData: any = new FormData();
    formData.append(
      'document_type_id',
      JSON.stringify(DOCUMENT_TYPE.OUTSOURCE_ORDER)
    );
    formData.append('outsource_id', JSON.stringify(docId));
    formData.append('file_obj', blob);

    savePdf(formData).then(data => {
      if (data === 'Not logged in!') {
        setCopyStart(false);
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setCopyStart(false);
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setCopyStart(false);
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            history.push(`/outsource-orders/${docId}/edit`, {
              state: docId,
              currentPage: currentPage
            });
          }
        }
      }
    });
  };

  const uploadPdf = async (pdfData: any, docId: number) => {
    let blob = await outsourcePdf(pdfData);

    const formData: any = new FormData();
    formData.append(
      'document_type_id',
      JSON.stringify(DOCUMENT_TYPE.OUTSOURCE_ORDER)
    );
    formData.append('outsource_id', JSON.stringify(docId));
    formData.append('file_obj', blob);

    savePdf(formData).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            getListOfOutSource();
          }
        }
      }
    });
  };

  const getTheDetailsOfOutsourceList = (id: number) => {
    getOutSourceDetails(id).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            uploadPdf(data.data, data.data.id);
          }
        }
      }
    });
  };

  const updateMemo = () => {
    const newMemo: string = memoDialog.trim();
    updateOutsourcePurchaseMemo(memoId, newMemo).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            getListOfOutSource();
            handleCloseMemoDialog();
          }
        }
      }
    });
  };

  const sendEmail = async (id: number) => {
    await getOutSourceDetails(id).then(async data => {
      setDocumentName(data.data.construction_name + '_外注発注書');
      await getPartnerDetails(data.data.partner_id).then(data => {
        setClientEmail(data.data.person_in_charge_email);
        setClientCompanyName(data.data.name);
        setClientName(data.data.person_in_charge_name);
      });
    });
  };

  const handleCopyStateMessage = (message: string) => {
    setCopyStateMessage(message);
    setOpenCopyStateMessage(true);
    setTimeout(() => {
      setOpenCopyStateMessage(false);
    }, 3000);
  };

  const handleOpenSelectModal = () => {
    setopenSelectModal(true);
  };
  const handleCloseSelectModal = () => {
    setConstructId('');
    setopenSelectModal(false);
  };
  const [fullWidth] = useState(true);
  const [maxWidth] = useState<DialogProps['maxWidth']>('sm');

  const getStatusFromId = (id: number) => {
    switch (id) {
      case 1:
        return <span>未着</span>;
      case 2:
        return <span>差戻し</span>;
      case 3:
        return <span>対応済み</span>;
      case 4:
        return <span>支払</span>;
      default:
        return <span></span>;
    }
  };

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent patternName='outsource_orders' />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>

          <Dialog
            open={openAlert}
            onClose={handleCloseAlert}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {'削除しますか？'}
            </DialogTitle>
            <DialogActions>
              <Button onClick={handleCloseAlert} color='primary'>
                キャンセル
              </Button>
              <Button
                onClick={() => {
                  deleteSelectedOutsources();
                }}
                color='primary'
                autoFocus
              >
                削除
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openAlertSingle}
            onClose={handleCloseAlertSingle}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {'削除しますか？'}
            </DialogTitle>
            <DialogActions>
              <Button onClick={handleCloseAlertSingle} color='primary'>
                キャンセル
              </Button>
              <Button
                onClick={() => {
                  handleCloseAlertSingle();
                  deleteOutsourceById();
                }}
                color='primary'
                autoFocus
              >
                削除
              </Button>
            </DialogActions>
          </Dialog>

          <div
            style={{
              display: 'flex',
              flexDirection: matches2 ? 'row' : 'column'
            }}
            className={classes.topList}
          >
            <div
              // 空アイテム
              className='empty-list'
              style={{ width: 15 }}
            ></div>
            <div
              className='border2'
              onClick={() => {
                history.push('/estimates');
              }}
            >
              <div className={classes.topBoxText}>見積書</div>
            </div>
            <div onClick={() => history.push('/invoices')} className='border2'>
              <div className={classes.topBoxText}>請求書</div>
            </div>
            <div
              onClick={() => history.push('/merchandise-orders')}
              className='border2'
            >
              <div className={classes.topBoxText}>商品発注書</div>
            </div>
            <div
              className='border2'
              style={{
                backgroundColor: '#F5F5F5',
                borderTopColor: '#0099CB',
                borderBottom: 'none'
              }}
            >
              <div className={classes.topBoxText} style={{ color: '#0099CB' }}>
                外注発注書
              </div>
            </div>
            <div
              className='border2'
              onClick={() => {
                history.push('/site-contacts');
              }}
            >
              <div className={classes.topBoxText}>現場連絡表</div>
            </div>
            <div
              onClick={() => history.push('/working-budgets')}
              className='border2'
            >
              <div className={classes.topBoxText}>実行予算表</div>
            </div>
            <div
              // 空アイテム
              className='empty-list'
              style={{ flexGrow: 1 }}
            ></div>
          </div>

          <div
            style={{
              overflow: 'hidden',
              backgroundColor: '#F5F5F5',
              padding: 15,
              minHeight: window.innerHeight - 150
            }}
          >
            <div>
              <Grid container>
                <Grid item xs={12} className={classes.searchField}>
                  <div
                    style={{ marginRight: 20, marginBottom: 10 }}
                    className='select-div'
                  >
                    <div style={{ paddingLeft: 5 }}>
                      <FormControl className={classes.formControl}>
                        <BasicSelect
                          value={status}
                          onChange={e => {
                            setStatus(parseInt(e.target.value));
                            setParams(prevParams => ({
                              ...prevParams,
                              status: parseInt(e.target.value)
                            }));
                          }}
                          inputProps={{ 'aria-label': 'age' }}
                          disableUnderline
                        >
                          <option value={0}>ステータス</option>
                          <option value={1}>未着</option>
                          <option value={2}>差戻し</option>
                          <option value={3}>対応済み</option>
                          <option value={4}>支払</option>
                        </BasicSelect>
                      </FormControl>
                    </div>
                  </div>

                  <div>
                    <input
                      value={constructSub}
                      maxLength={60}
                      onChange={e => {
                        setConstructSub(e.target.value);
                        setParams(prevParams => ({
                          ...prevParams,
                          constructSub: e.target.value
                        }));
                      }}
                      style={{
                        marginBottom: 10,
                        marginRight: 20,
                        backgroundColor: '#FFFFFF'
                      }}
                      className={classes.formControl1}
                      placeholder='工事件名'
                    />
                  </div>

                  <div>
                    <input
                      value={constructCode}
                      maxLength={10}
                      onChange={e => {
                        setConstructCode(e.target.value);
                        setParams(prevParams => ({
                          ...prevParams,
                          constructCode: e.target.value
                        }));
                      }}
                      style={{
                        marginBottom: 10,
                        marginRight: 20,
                        backgroundColor: '#FFFFFF'
                      }}
                      className={classes.formControl1}
                      placeholder='工事番号'
                    />
                  </div>

                  <div
                    style={{ marginRight: 20, marginBottom: 10 }}
                    className='select-div'
                  >
                    <div style={{ paddingLeft: 5 }}>
                      <FormControl className={classes.formControl}>
                        <BasicSelect
                          value={userId}
                          onChange={e => {
                            setUserId(parseInt(e.target.value));
                            setParams(prevParams => ({
                              ...prevParams,
                              userId: parseInt(e.target.value)
                            }));
                          }}
                          inputProps={{ 'aria-label': 'age' }}
                          disableUnderline
                        >
                          <option value={0}>営業担当</option>
                          {getUserSelectOptions(userData)}
                        </BasicSelect>
                      </FormControl>
                    </div>
                  </div>

                  <div>
                    <input
                      value={supplierName}
                      maxLength={38}
                      onChange={e => {
                        setSupplierName(e.target.value);
                        setParams(prevParams => ({
                          ...prevParams,
                          supplierName: e.target.value
                        }));
                      }}
                      style={{
                        marginBottom: 10,
                        marginRight: 20,
                        backgroundColor: '#FFFFFF'
                      }}
                      className={classes.formControl1}
                      placeholder='発注先'
                    />
                  </div>

                  <div>
                    <input
                      value={customerName}
                      maxLength={30}
                      onChange={e => {
                        setCustomerName(e.target.value);
                        setParams(prevParams => ({
                          ...prevParams,
                          customerName: e.target.value
                        }));
                      }}
                      style={{
                        marginBottom: 10,
                        marginRight: 20,
                        backgroundColor: '#FFFFFF'
                      }}
                      className={classes.formControl1}
                      placeholder='顧客名'
                    />
                  </div>
                </Grid>

                <Grid item xs={12} className={classes.searchField}>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <span style={{ marginRight: '5px' }}> 工事の竣工日 : </span>
                    <div
                      className='select-div'
                      style={{
                        marginBottom: 10,
                        marginRight: 20,
                        backgroundColor: '#FFFFFF',
                        height: 27,
                        paddingBottom: 5,
                        paddingLeft: 5
                      }}
                    >
                      <DatePickerInput
                        id='date-picker-inline'
                        date={selectedConstructFromDate}
                        emptyLabel='開始日'
                        onChange={handleConstructFromDateChange}
                        maxDate={
                          selectedConstructEndDate
                            ? selectedConstructEndDate
                            : undefined
                        }
                      />
                    </div>
                  </div>
                  <span style={{ marginRight: '20px', fontSize: '20px' }}>
                    ~
                  </span>
                  <div
                    className='select-div'
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF',
                      height: 27,
                      paddingBottom: 5,
                      paddingLeft: 5
                    }}
                  >
                    <DatePickerInput
                      id='date-picker-inline'
                      date={selectedConstructEndDate}
                      emptyLabel='終了日'
                      onChange={handleConstructEndDateChange}
                      minDate={
                        selectedConstructFromDate
                          ? selectedConstructFromDate
                          : undefined
                      }
                    />
                  </div>
                </Grid>
                <Grid item xs={12} className={classes.searchField}>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <span style={{ marginRight: '5px' }}>支払予定日 : </span>
                    <div
                      style={{
                        marginBottom: 10,
                        marginRight: 20,
                        backgroundColor: '#FFFFFF',
                        height: 27,
                        paddingBottom: 5,
                        paddingLeft: 5
                      }}
                      className={'select-div'}
                    >
                      <DatePickerInput
                        id='date-picker-inline'
                        date={selectedJobFromDate}
                        emptyLabel='開始日'
                        onChange={handleJobFromDateChange}
                        maxDate={
                          selectedJobEndDate ? selectedJobEndDate : undefined
                        }
                      />
                    </div>
                    <span style={{ marginRight: '20px', fontSize: '20px' }}>
                      ~
                    </span>
                    <div
                      style={{
                        marginBottom: 10,
                        marginRight: 20,
                        backgroundColor: '#FFFFFF',
                        height: 27,
                        paddingBottom: 5,
                        paddingLeft: 5
                      }}
                      className={'select-div'}
                    >
                      <DatePickerInput
                        id='date-picker-inline'
                        date={selectedJobEndDate}
                        emptyLabel='終了日'
                        onChange={handleJobEndDateChange}
                        minDate={
                          selectedJobFromDate ? selectedJobFromDate : undefined
                        }
                      />
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <span style={{ marginRight: '5px' }}>発注日 : </span>
                    <div
                      style={{
                        marginBottom: 10,
                        marginRight: 20,
                        backgroundColor: '#FFFFFF',
                        height: 27,
                        paddingBottom: 5,
                        paddingLeft: 5
                      }}
                      className={'select-div'}
                    >
                      <DatePickerInput
                        id='date-picker-inline'
                        date={selectedOrderFromDate}
                        emptyLabel='開始日'
                        onChange={handleOrderFromDateChange}
                        maxDate={
                          selectedOrderDate ? selectedOrderDate : undefined
                        }
                      />
                    </div>
                  </div>
                  <span style={{ marginRight: '20px', fontSize: '20px' }}>
                    ~
                  </span>
                  <div
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF',
                      height: 27,
                      paddingBottom: 5,
                      paddingLeft: 5
                    }}
                    className={'select-div'}
                  >
                    <DatePickerInput
                      id='date-picker-inline'
                      date={selectedOrderDate}
                      emptyLabel='終了日'
                      onChange={handleOrderDateChange}
                      minDate={
                        selectedOrderFromDate
                          ? selectedOrderFromDate
                          : undefined
                      }
                    />
                  </div>
                </Grid>
                <Grid item xs={12} className={classes.searchField}>
                  <div>
                    <input
                      onChange={(e: any) => {
                        setCurrentPage(1);
                        if (parseInt(e.target.value) > 0) {
                          setBillingTotalStart(parseInt(e.target.value));
                          setParams(prevParams => ({
                            ...prevParams,
                            billingTotalStart: parseInt(e.target.value)
                          }));
                        } else {
                          setBillingTotalStart(null);
                          setParams(prevParams => ({
                            ...prevParams,
                            billingTotalStart: null
                          }));
                        }
                      }}
                      style={{
                        marginBottom: 10,
                        marginRight: 20,
                        backgroundColor: '#FFFFFF'
                      }}
                      className={classes.formControl1}
                      placeholder='予定原価合計'
                      value={billingTotalStart > 0 ? billingTotalStart : ''}
                      maxLength={16}
                    />
                  </div>
                  <span style={{ marginRight: '20px', fontSize: '20px' }}>
                    ~
                  </span>
                  <div>
                    <input
                      onChange={(e: any) => {
                        setCurrentPage(1);
                        if (parseInt(e.target.value) > 0) {
                          setBillingTotalEnd(parseInt(e.target.value));
                          setParams(prevParams => ({
                            ...prevParams,
                            billingTotalEnd: parseInt(e.target.value)
                          }));
                        } else {
                          setBillingTotalEnd(null);
                          setParams(prevParams => ({
                            ...prevParams,
                            billingTotalEnd: null
                          }));
                        }
                      }}
                      style={{
                        marginBottom: 10,
                        marginRight: 20,
                        backgroundColor: '#FFFFFF'
                      }}
                      className={classes.formControl1}
                      placeholder='予定原価合計'
                      value={billingTotalEnd > 0 ? billingTotalEnd : ''}
                      maxLength={16}
                    />
                  </div>
                  <div>
                    <input
                      value={prefecture}
                      maxLength={5}
                      onChange={e => {
                        setPrefecture(e.target.value);
                        setParams(prevParams => ({
                          ...prevParams,
                          prefecture: e.target.value
                        }));
                      }}
                      style={{
                        marginBottom: 10,
                        marginRight: 20,
                        backgroundColor: '#FFFFFF'
                      }}
                      className={classes.formControl1}
                      placeholder='都道府県'
                    />
                  </div>
                  <div>
                    <input
                      value={address}
                      maxLength={120}
                      onChange={e => {
                        setAddress(e.target.value);
                        setParams(prevParams => ({
                          ...prevParams,
                          address: e.target.value
                        }));
                      }}
                      style={{
                        marginBottom: 10,
                        marginRight: 20,
                        backgroundColor: '#FFFFFF'
                      }}
                      className={classes.formControl1}
                      placeholder='市区町村・番地など'
                    />
                  </div>
                  <div>
                    <Button
                      style={{
                        marginBottom: 10,
                        marginRight: 20,
                        backgroundColor: buttonColor
                      }}
                      variant='contained'
                      color='primary'
                      onClick={() => {
                        getListOfOutSource();
                        setCurrentPage(1);
                      }}
                    >
                      検索
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </div>

            <div
              style={{
                padding: 15,
                backgroundColor: '#FFFFFF',
                borderRadius: 5
              }}
            >
              <div className={classes.topContainer}>
                <div style={{ fontSize: 20, paddingTop: 12 }}>
                  外注発注書一覧
                </div>
                <div />
                <div className={classes.btnContainer}>
                  <div
                    style={{ marginBottom: 10, width: 125 }}
                    className='select-div'
                  >
                    <div style={{ paddingLeft: 5 }}>
                      <FormControl className={classes.formControl}>
                        <BasicSelect
                          value={displayLimit}
                          onChange={handleDisplayLimitChange}
                          inputProps={{ 'aria-label': 'age' }}
                          disableUnderline
                        >
                          {/* <option value={0}>
                          結果の制限</option> */}
                          <option value={10}>10件</option>
                          <option value={30}>30件</option>
                          <option value={50}>50件</option>
                          <option value={100}>100件</option>
                          <option value={150}>150件</option>
                          <option value={200}>200件</option>
                        </BasicSelect>
                      </FormControl>
                    </div>
                  </div>
                  <CustomTooltip
                    title={tooltipContents.documenCreateNew}
                    placement='top'
                  >
                    <Button
                      style={{
                        backgroundColor: buttonColor,
                        marginBottom: 10,
                        marginLeft: 15
                      }}
                      variant='contained'
                      color='secondary'
                      startIcon={<NoteAddIcon />}
                      onClick={handleOpenSelectModal}
                    >
                      新規作成
                    </Button>
                  </CustomTooltip>
                  <Dialog
                    //maxWidth="xs"
                    fullWidth={fullWidth}
                    maxWidth={maxWidth}
                    open={openSelectModal}
                    onClose={handleCloseSelectModal}
                    aria-labelledby='max-width-dialog-title'
                  >
                    <DialogTitle id='confirmation-dialog-title'>
                      帳票を作成する工事を選択してください
                    </DialogTitle>
                    <DialogContent>
                      <div>
                        <input
                          value={constructSubForCreate}
                          maxLength={60}
                          onChange={e => {
                            setConstructSubForCreate(e.target.value);
                          }}
                          style={{
                            marginBottom: 10,
                            marginRight: 20,
                            backgroundColor: '#FFFFFF',
                            width: '100%'
                          }}
                          className={classes.formControl1}
                          placeholder='工事名'
                        />
                      </div>
                      <TableContainer>
                        <Table aria-label='sticky table'>
                          <TableHead>
                            <TableRow>
                              <TableCell
                                style={{
                                  width: '5%',
                                  padding: 0
                                }}
                                align={'center'}
                              ></TableCell>
                              <TableCell
                                align={'center'}
                                style={{
                                  width: '14%',
                                  padding: 0
                                }}
                              >
                                工事番号
                              </TableCell>
                              <TableCell
                                style={{
                                  width: '14%',
                                  padding: 0
                                }}
                                align={'center'}
                              >
                                工事名
                              </TableCell>

                              <TableCell
                                style={{
                                  width: '14%',
                                  padding: 0
                                }}
                                align={'center'}
                              >
                                案件種別
                              </TableCell>
                              <TableCell
                                style={{
                                  width: '14%',
                                  padding: 0
                                }}
                                align={'center'}
                              >
                                顧客名
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {filteredConstructionData.length > 0 &&
                              filteredConstructionData.map((option: any) => {
                                return (
                                  <TableRow key={option.id}>
                                    <StyledTableCell
                                      align='center'
                                      style={{
                                        width: '5%',
                                        padding: 0,
                                        paddingLeft: 12
                                      }}
                                    >
                                      <RadioGroup
                                        aria-label='Select Customer Name'
                                        name='Select Customer Name'
                                        value={constructId as string}
                                        onChange={e =>
                                          setConstructId(e.target.value)
                                        }
                                      >
                                        <FormControlLabel
                                          value={option.id as string}
                                          checked={
                                            Number(constructId) ===
                                            Number(option.id)
                                          }
                                          key={option.id}
                                          control={
                                            <Radio
                                              style={{ color: '#758283' }}
                                            />
                                          }
                                          label={''}
                                        />
                                      </RadioGroup>
                                    </StyledTableCell>
                                    <StyledTableCell
                                      align={'center'}
                                      style={{
                                        width: '10%',
                                        padding: 0
                                      }}
                                    >
                                      {option.code}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      align={'center'}
                                      style={{
                                        width: '14%',
                                        padding: 0
                                      }}
                                    >
                                      {option.name}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      align={'center'}
                                      style={{
                                        width: '14%',
                                        padding: 0
                                      }}
                                    >
                                      {option.type}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      align={'center'}
                                      style={{
                                        width: '14%',
                                        padding: 0
                                      }}
                                    >
                                      {option.customer_name
                                        ? option.customer_name
                                        : ''}
                                    </StyledTableCell>
                                  </TableRow>
                                );
                              })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        autoFocus
                        className={classes.cancelButton}
                        onClick={() => {
                          handleCloseSelectModal();
                          setConstructSubForCreate('');
                        }}
                      >
                        キャンセル
                      </Button>
                      <Button
                        className={classes.submitButton}
                        disabled={constructId === ''}
                        variant='contained'
                        onClick={() => {
                          history.push(`/outsource-orders/create`, {
                            //工事番号
                            constructId: constructId,
                            params: params
                          });
                        }}
                      >
                        新規作成
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <CustomTooltip
                    title={tooltipContents.documenSelectDeletet}
                    placement='top'
                  >
                    <Button
                      style={{
                        backgroundColor: buttonColor,
                        marginLeft: 15,
                        marginBottom: 10
                      }}
                      variant='contained'
                      color='secondary'
                      startIcon={<DeleteIcon />}
                      onClick={() => {
                        if (selectedIds.arr.length <= 0) {
                          alert('対象を選択してください。');
                        } else {
                          handleClickOpenAlert();
                        }
                      }}
                    >
                      選択削除
                    </Button>
                  </CustomTooltip>
                  <CustomTooltip
                    title={tooltipContents.documenExport}
                    placement='top'
                  >
                    <Button
                      style={{
                        backgroundColor: buttonColor,
                        marginBottom: 10,
                        marginLeft: 15
                      }}
                      onClick={handleOpenModal}
                      variant='contained'
                      color='secondary'
                      startIcon={<GetAppIcon />}
                    >
                      エクスポート
                    </Button>
                  </CustomTooltip>
                </div>
              </div>
              <Dialog
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby='max-width-dialog-title'
              >
                <DialogContent>
                  <DialogContentText id='alert-dialog-description'>
                    <div>
                      <div
                        className='border1'
                        style={{ display: 'flex', flexDirection: 'row' }}
                      >
                        <div style={{ flex: 3 }}>
                          <div
                            style={{ padding: 10, backgroundColor: mainColor }}
                          >
                            <div style={{ color: '#FFFFFF' }}>エクスポート</div>
                          </div>
                        </div>
                      </div>

                      {checkListOptions.map((i: any, index) => (
                        <div
                          className='border1'
                          style={{ display: 'flex', flexDirection: 'row' }}
                        >
                          <div
                            style={{
                              flex: 3,
                              backgroundColor:
                                index % 2 === 0 ? '#F5F5F5' : '#FFFFFF'
                            }}
                          >
                            <div style={{ padding: 3 }}>
                              <Checkbox
                                name='expertCheckbox'
                                checked={
                                  myCheckExport.includes(
                                    Object.keys(i).toString()
                                  )
                                    ? true
                                    : false
                                }
                                onClick={e => {
                                  var ind = myCheckExport.indexOf(
                                    Object.keys(i).toString()
                                  );
                                  if (ind === -1) {
                                    setMyCheckExport([
                                      ...myCheckExport,
                                      Object.keys(i).toString()
                                    ]);
                                  } else {
                                    setMyCheckExport(
                                      myCheckExport.filter(
                                        (char: any, aa: any) => aa !== ind
                                      )
                                    );
                                  }
                                }}
                                style={{
                                  color: myCheckExport.includes(
                                    Object.keys(i).toString()
                                  )
                                    ? buttonColor
                                    : '#758283'
                                }}
                              />
                              {Object.values(i)}
                            </div>
                          </div>
                        </div>
                      ))}
                      <div></div>
                    </div>
                  </DialogContentText>
                </DialogContent>
                <div
                  style={{
                    marginBottom: 20,
                    marginTop: 10,
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                >
                  <Button
                    style={{ backgroundColor: buttonColor }}
                    variant='contained'
                    color='primary'
                    onClick={handleExport}
                    startIcon={<GetAppIcon />}
                  >
                    保存
                  </Button>
                  <CSVLink
                    data={transactionData}
                    filename='外注発注書.csv'
                    className='hidden'
                    ref={csvLink}
                    target='_blank'
                  />
                </div>
              </Dialog>

              <MemoDialog
                handleCloseMemoDialog={handleCloseMemoDialog}
                openMemoDialog={openMemoDialog}
                memoDialog={memoDialog}
                updateMemo={updateMemo}
                setMemoDialog={setMemoDialog}
              />

              <Dialog
                open={openCopyDialog}
                onClose={handleCloseCopyDialog}
                scroll='paper'
                aria-labelledby='set_construct_title'
                aria-describedby='constructs'
              >
                <DialogTitle id='set_construct_title'>
                  コピー先の工事を選択してください
                </DialogTitle>
                <DialogContent dividers>
                  <DialogContentText id='constructs'>
                    <div>
                      <input
                        value={constructSubForCopy}
                        onChange={e => {
                          setConstructSubForCopy(e.target.value);
                        }}
                        style={{
                          marginBottom: 10,
                          marginRight: 20,
                          backgroundColor: '#FFFFFF',
                          width: '100%'
                        }}
                        className={classes.formControl1}
                        placeholder='工事名'
                      />
                    </div>
                    <List>
                      <ListItem
                        button
                        selected={selectedConstructId === originalConstructId}
                        onClick={() => {
                          handleToggleSetConstruct();
                        }}
                      >
                        <Checkbox
                          checked={selectedConstructId === originalConstructId}
                          color='primary'
                          style={{ marginRight: 16 }}
                        />
                        <ListItemText>元の工事にコピー</ListItemText>
                      </ListItem>
                      {filteredConstructionData.map((construct: any) => (
                        <ListItem
                          button
                          selected={selectedConstructId === construct.id}
                          onClick={() => {
                            setSelectedConstructId(construct.id);
                          }}
                        >
                          <FormControlLabel
                            control={<Radio color='primary' />}
                            checked={selectedConstructId === construct.id}
                            label=''
                            style={{ marginLeft: 0 }}
                          />
                          <ListItemText>{construct.name}</ListItemText>
                        </ListItem>
                      ))}
                    </List>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => {
                      handleCloseCopyDialog();
                      setConstructSubForCopy('');
                    }}
                    color='primary'
                  >
                    キャンセル
                  </Button>
                  <Button
                    onClick={() => {
                      setCopyStart(true);
                      copySelectedOutSources(
                        selectedOutsourceId,
                        selectedConstructId
                      );
                    }}
                    color='primary'
                  >
                    {copyStart ? (
                      <CircularProgress
                        style={{ color: '#0099CC', height: 20, width: 20 }}
                      />
                    ) : (
                      <>コピーする</>
                    )}
                  </Button>
                </DialogActions>
              </Dialog>

              <TableContainer component={Paper}>
                <Table className={classes.main} aria-label='customized table'>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell
                        style={{ minWidth: 20 }}
                        className={classes.table}
                        align='center'
                      >
                        <CustomTooltip
                          title={tooltipContents.selectDelete}
                          placement='top'
                        >
                          <Checkbox
                            checked={isSelected}
                            onClick={() => {
                              setSelection(!isSelected);
                              selectAllCheckBoxPressed();
                            }}
                            style={{
                              color: isSelected ? buttonColor : '#FFFFFF'
                            }}
                          />
                        </CustomTooltip>
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 110 }}
                        className={classes.table}
                        align='center'
                      >
                        外注発注書番号
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 120 }}
                        className={classes.table}
                        align='center'
                      >
                        ステータス
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 300 }}
                        className={classes.table}
                        align='center'
                      >
                        工事件名
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 150 }}
                        className={classes.table}
                        align='center'
                      >
                        営業担当
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 150 }}
                        className={classes.table}
                        align='center'
                      >
                        工事種別
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 160 }}
                        className={classes.table}
                        align='center'
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <div style={{ color: '#FFFFFF', fontWeight: 'bold' }}>
                            支払予定日
                          </div>
                          <SortButton
                            buttonName='payment_date'
                            getListData={getListOfOutSource}
                            sortButtonName={sortButtonName}
                            setSortButtonName={setSortButtonName}
                            setCurrentPage={setCurrentPage}
                            changeSortParams={changeSortParams}
                          />
                        </div>
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 160 }}
                        className={classes.table}
                        align='center'
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <div style={{ color: '#FFFFFF', fontWeight: 'bold' }}>
                            発注日
                          </div>
                          <SortButton
                            buttonName='order_date'
                            getListData={getListOfOutSource}
                            sortButtonName={sortButtonName}
                            setSortButtonName={setSortButtonName}
                            setCurrentPage={setCurrentPage}
                            changeSortParams={changeSortParams}
                          />
                        </div>
                      </StyledTableCell>

                      <StyledTableCell
                        style={{ minWidth: 160 }}
                        className={classes.table}
                        align='center'
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <div style={{ color: '#FFFFFF', fontWeight: 'bold' }}>
                            開始日
                          </div>
                          <SortButton
                            buttonName='job_start_date'
                            getListData={getListOfOutSource}
                            sortButtonName={sortButtonName}
                            setSortButtonName={setSortButtonName}
                            setCurrentPage={setCurrentPage}
                            changeSortParams={changeSortParams}
                          />
                        </div>
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 160 }}
                        className={classes.table}
                        align='center'
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <div style={{ color: '#FFFFFF', fontWeight: 'bold' }}>
                            終了日
                          </div>
                          <SortButton
                            buttonName='job_end_date'
                            getListData={getListOfOutSource}
                            sortButtonName={sortButtonName}
                            setSortButtonName={setSortButtonName}
                            setCurrentPage={setCurrentPage}
                            changeSortParams={changeSortParams}
                          />
                        </div>
                      </StyledTableCell>

                      <StyledTableCell
                        style={{ minWidth: 180 }}
                        className={classes.table}
                        align='center'
                      >
                        発注先
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 140 }}
                        className={classes.table}
                        align='center'
                      >
                        予定原価合計（税抜）
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 140 }}
                        className={classes.table}
                        align='center'
                      >
                        予定原価合計（税込）
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 100 }}
                        className={classes.table}
                        align='center'
                      >
                        請求金額（税込）
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 140 }}
                        className={classes.table}
                        align='center'
                      >
                        差額
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 80 }}
                        className={classes.table}
                        align='center'
                      >
                        メモ
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 240 }}
                        className={classes.multiLinesTable}
                        align='center'
                      >
                        <div
                          className={classes.subCell}
                          style={{ borderBottom: '1px #CCCCCC solid' }}
                        >
                          支払いサイト
                        </div>
                        <div>
                          <StyledTableCell
                            style={{
                              minWidth: 80,
                              backgroundColor: '#0099CC',
                              fontWeight: 'bold'
                            }}
                            className={classes.subCell}
                            align='center'
                          >
                            締日
                          </StyledTableCell>
                          <StyledTableCell
                            style={{
                              minWidth: 80,
                              backgroundColor: '#0099CC',
                              fontWeight: 'bold'
                            }}
                            className={classes.subCell}
                            align='center'
                          >
                            支払月
                          </StyledTableCell>
                          <StyledTableCell
                            style={{
                              minWidth: 80,
                              backgroundColor: '#0099CC',
                              fontWeight: 'bold'
                            }}
                            className={classes.subCell}
                            align='center'
                          >
                            支払日
                          </StyledTableCell>
                        </div>
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 140 }}
                        className={classes.table}
                        align='center'
                      ></StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 130 }}
                        className={classes.table}
                        align='center'
                      ></StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 120 }}
                        className={classes.table}
                        align='center'
                      ></StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: 160 }}
                        className={classes.table}
                        align='center'
                      ></StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {apiData.map((row: any, index: number) => (
                      <StyledTableRow
                        className='click_table_row'
                        // onClick={() => {
                        //   history.push(`/outsource-orders/${row.id}/edit`, {
                        //     state: row.id,
                        //   });
                        // }}
                      >
                        <StyledTableCell
                          className={classes.table1}
                          align='center'
                        >
                          <CustomTooltip
                            title={tooltipContents.selectDelete}
                            placement='top'
                          >
                            <Checkbox
                              checked={checked.check[index] ? true : false}
                              onClick={() => {
                                handleChange(index);
                                let newArr = selectedIds.arr;
                                if (!checked.check[index] && !pressed[index]) {
                                  newArr.push(row.id);
                                  setSelectedIds({ arr: newArr });
                                } else {
                                  var ind = selectedIds.arr.indexOf(row.id);
                                  if (ind !== -1)
                                    selectedIds.arr.splice(ind, 1);
                                }
                                setCheckBoxSelected(!checkBoxSelected);
                              }}
                              style={{
                                color: checked.check[index]
                                  ? buttonColor
                                  : '#758283'
                              }}
                            />
                          </CustomTooltip>
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table1}
                          align='left'
                          onClick={() => {
                            history.push(`/outsource-orders/${row.id}/edit`, {
                              rowId: row.id,
                              params: params,
                              currentPage: currentPage
                            });
                          }}
                        >
                          {row.code}
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table1}
                          align='center'
                        >
                          {userPermission === 1 || userPermission === null ? (
                            <select
                              value={row.status}
                              onChange={text => {
                                updateStatus(
                                  parseInt(row.id),
                                  parseInt(text.target.value)
                                );
                              }}
                              className={classes.inputBottom}
                              style={{ height: 35 }}
                            >
                              <option value={1}>未着</option>
                              <option value={2}>差戻し</option>
                              <option value={3}>対応済み</option>
                              <option value={4}>支払</option>
                            </select>
                          ) : (
                            getStatusFromId(row.status)
                          )}
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table1}
                          align='left'
                          onClick={() => {
                            history.push(`/outsource-orders/${row.id}/edit`, {
                              rowId: row.id,
                              params: params,
                              currentPage: currentPage
                            });
                          }}
                        >
                          {row.construct_sub}
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table1}
                          align='left'
                          onClick={() => {
                            history.push(`/outsource-orders/${row.id}/edit`, {
                              rowId: row.id,
                              params: params,
                              currentPage: currentPage
                            });
                          }}
                        >
                          {row.site_user_name}
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table1}
                          align='left'
                          onClick={() => {
                            history.push(`/outsource-orders/${row.id}/edit`, {
                              rowId: row.id,
                              params: params,
                              currentPage: currentPage
                            });
                          }}
                        >
                          {row.construct_type}
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table1}
                          align='left'
                          onClick={() => {
                            history.push(`/outsource-orders/${row.id}/edit`, {
                              rowId: row.id,
                              params: params,
                              currentPage: currentPage
                            });
                          }}
                        >
                          {row.payment_date}
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table1}
                          align='left'
                          onClick={() => {
                            history.push(`/outsource-orders/${row.id}/edit`, {
                              rowId: row.id,
                              params: params,
                              currentPage: currentPage
                            });
                          }}
                        >
                          {row.order_date}
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table1}
                          align='left'
                          onClick={() => {
                            history.push(`/outsource-orders/${row.id}/edit`, {
                              rowId: row.id,
                              params: params,
                              currentPage: currentPage
                            });
                          }}
                        >
                          {row.job_start_date}
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table1}
                          align='left'
                          onClick={() => {
                            history.push(`/outsource-orders/${row.id}/edit`, {
                              rowId: row.id,
                              params: params,
                              currentPage: currentPage
                            });
                          }}
                        >
                          {row.job_end_date}
                        </StyledTableCell>

                        <StyledTableCell
                          className={classes.table1}
                          align='left'
                          onClick={() => {
                            history.push(`/outsource-orders/${row.id}/edit`, {
                              rowId: row.id,
                              params: params,
                              currentPage: currentPage
                            });
                          }}
                        >
                          {row.partner}
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table1}
                          align='right'
                          onClick={() => {
                            history.push(`/outsource-orders/${row.id}/edit`, {
                              rowId: row.id,
                              params: params,
                              currentPage: currentPage
                            });
                          }}
                        >
                          {parsePrice(row.total_amount)}
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table1}
                          align='right'
                          onClick={() => {
                            history.push(`/outsource-orders/${row.id}/edit`, {
                              rowId: row.id,
                              params: params,
                              currentPage: currentPage
                            });
                          }}
                        >
                          {parsePrice(row.total_price)}
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table1}
                          align='right'
                        >
                          {!calcInvoiceBillingTotals ? (
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row'
                              }}
                            >
                              <NumberInputProductPurchaseOrders
                                type='number'
                                // 請求金額入力時に発火する関数
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  clearTimeout(timer);
                                  const newTimer = setTimeout(() => {
                                    try {
                                      if (
                                        row.status === 2 &&
                                        !parseInt(e.target.value)
                                      ) {
                                        setErrorMessage(
                                          'ステータスが差戻し時は請求金額を入力してください。'
                                        );
                                        setOpen(true);
                                        return;
                                      }
                                      setInvoiceBillingTotals(
                                        invoiceBillingTotals.map(item => {
                                          if (item.id === row.id) {
                                            return {
                                              id: item.id,
                                              invoice_billing_total: parseInt(
                                                e.target.value
                                              )
                                            };
                                          } else {
                                            return item;
                                          }
                                        })
                                      );
                                    } catch {
                                      console.log('変更失敗');
                                    }
                                  }, 500);
                                  setTimer(newTimer);
                                }}
                                rowId={row.id}
                                changeInvoiceBillingTotal={
                                  changeInvoiceBillingTotal
                                }
                                className={classes.formControl1}
                                value={
                                  invoiceBillingTotals.find(
                                    item => item.id === row.id
                                  )
                                    ? invoiceBillingTotals.find(
                                        item => item.id === row.id
                                      )?.invoice_billing_total
                                    : undefined
                                }
                              />
                            </div>
                          ) : undefined}
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table1}
                          align='right'
                          onClick={() => {
                            history.push(`/outsource-orders/${row.id}/edit`, {
                              rowId: row.id,
                              params: params,
                              currentPage: currentPage
                            });
                          }}
                        >
                          {invoiceBillingTotals.find(item => item.id === row.id)
                            ?.invoice_billing_total
                            ? parsePrice(
                                invoiceBillingTotals.find(
                                  item => item.id === row.id
                                )!.invoice_billing_total -
                                  parseInt(row.total_price)
                              )
                            : undefined}
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table1}
                          style={{ whiteSpace: 'nowrap' }}
                          align='left'
                          data-tip={row}
                          data-for={row.id.toString()}
                        >
                          {row.memo.length < 10
                            ? row.memo
                            : row.memo.substring(0, 10) + '...'}
                          <IconButton
                            onClick={() => {
                              setMemoDialog(row.memo);
                              setOpenMemoDialog(true);
                              setMemoId(row.id);
                            }}
                          >
                            <CreateIcon />
                          </IconButton>
                        </StyledTableCell>

                        <StyledTableCellSite
                          className={classes.table1}
                          align='right'
                          onClick={() => {
                            history.push(`/outsource-orders/${row.id}/edit`, {
                              rowId: row.id,
                              params: params,
                              currentPage: currentPage
                            });
                          }}
                        >
                          <StyledTableCell
                            className={classes.subTable1}
                            style={{ width: 80, textAlign: 'center' }}
                            align='right'
                          >
                            {row.closing_date == '末日'
                              ? row.closing_date
                              : `${row.closing_date}日`}
                          </StyledTableCell>
                          <StyledTableCell
                            className={classes.subTable1}
                            style={{ width: 80, textAlign: 'center' }}
                            align='right'
                          >
                            {row.payment_site_name.split('-')[0]}
                          </StyledTableCell>
                          <StyledTableCell
                            className={classes.subTable1}
                            style={{ width: 80, textAlign: 'center' }}
                            align='right'
                          >
                            {row.payment_site_name.split('-')[1]}日
                          </StyledTableCell>
                        </StyledTableCellSite>

                        <StyledTableCell
                          className={classes.table1}
                          align='center'
                        >
                          <Button
                            style={{ backgroundColor: buttonColor }}
                            variant='contained'
                            color='primary'
                            startIcon={<FileCopyIcon />}
                            onClick={() => {
                              // if (
                              //   window.confirm("[OK]をクリックして確認します。")
                              // ) {
                              //   copySelectedOutSources(row.id);
                              // }
                              setSelectedConstructId(row.construct_id);
                              setOriginalConstructId(row.construct_id);
                              setSelectedOutsourceId(row.id);
                              setOpenCopyDialog(true);
                            }}
                          >
                            コピー
                          </Button>
                        </StyledTableCell>

                        <StyledTableCell
                          className={classes.table1}
                          align='center'
                        >
                          {row.document_id ? (
                            <div style={{ color: '#00000' }}>保存済み</div>
                          ) : (
                            <Button
                              style={{ backgroundColor: buttonColor }}
                              variant='contained'
                              color='primary'
                              onClick={() => {
                                setClickedDocumentId([
                                  ...clickedDocumentId,
                                  row.id
                                ]);
                                getTheDetailsOfOutsourceList(row.id);
                              }}
                            >
                              {clickedDocumentId.includes(row.id) ? (
                                <CircularProgress
                                  style={{
                                    color: '#FFFFFF',
                                    height: 20,
                                    width: 20
                                  }}
                                />
                              ) : (
                                <>PDF保存</>
                              )}
                            </Button>
                          )}
                        </StyledTableCell>

                        <StyledTableCell
                          className={classes.table1}
                          align='center'
                        >
                          <Button
                            style={{ backgroundColor: buttonColor }}
                            variant='contained'
                            color='primary'
                            onClick={() => {
                              setIdToDelete(row.id);
                              handleClickOpenAlertSingle();
                            }}
                            startIcon={<DeleteIcon />}
                          >
                            削除
                          </Button>
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table1}
                          align='center'
                        >
                          <Button
                            style={{ backgroundColor: buttonColor }}
                            variant='contained'
                            color='primary'
                            onClick={() => {
                              sendEmail(row.id);
                              setDocumentId(row.document_id);
                              setModalOpen(true);
                            }}
                          >
                            メール送信
                          </Button>
                        </StyledTableCell>
                        <ReactTooltip
                          id={row.id.toString()}
                          type='light'
                          border={true}
                          className={classes.tooltip_old}
                          getContent={() =>
                            row.memo ? (
                              <React.Fragment>
                                <p style={{ overflowWrap: 'break-word' }}>
                                  {row.memo}
                                </p>
                              </React.Fragment>
                            ) : null
                          }
                        />
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
                {!loading && apiData.length === 0 && (
                  <div className={classes.container}>データがありません</div>
                )}
              </TableContainer>
              <PaginationComponent
                page={currentPage}
                pageCount={pageCount}
                setCurrentPage={setCurrentPage}
              />
            </div>
          </div>
        </div>
      )}
      <FooterComponent />

      {/* フォルダ削除確認モーダル */}
      <AlertModal
        openAlertModal={modalOpen}
        setOpenAlertModal={setModalOpen}
        handleCopyStateMessage={handleCopyStateMessage}
        clientName={clientName}
        setClientName={setClientName}
        clientEmail={clientEmail}
        setClientEmail={setClientEmail}
        clientCompanyName={clientCompanyName}
        setClientCompanyName={setClientCompanyName}
        documentId={documentId}
        documentName={documentName}
        setErrorMessage={setErrorMessage}
        setOpen={setOpen}
      />

      {/* リンクURLのコピー成否メッセージ */}
      {openCopyStateMessage && (
        <div className={classes.copyStateMessage}>
          <div>{copyStateMessage}</div>
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => setOpenCopyStateMessage(false)}
          >
            OK
          </div>
        </div>
      )}
    </div>
  );
};
